import './App.css';

function App() {
  return (
    <div className="App">
      <div style={{ fontStyle: 'bold' }}>coming soon!</div>
    </div>
  );
}

export default App;
